import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
// import Personal from '../views/personal/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/sample-reports',
    name: 'sampleReports',
    component: () => import(/* webpackChunkName: "sampleReports" */ '../views/SampleReports/sampleReports.vue')
  },
  {
    path: '/about/about-us',
    name: 'aboutUs',
    component: () => import(/* webpackChunkName: "aboutUs" */ '../views/About/aboutUs.vue')
  },
  {
    path: '/about/partner-brand',
    name: 'partnerBrandSide',
    component: () => import(/* webpackChunkName: "partnerBrandSide" */ '../views/About/partnerBrandSide.vue')
  },
  {
    path: '/vehicle-history/introduction',
    name: 'vehicleHistory',
    component: () => import(/* webpackChunkName: "vehicleHistory" */ '../views/VehicleHistory/vehicleHistory.vue')
  },
  {
    path: '/vehicle-history/vin-introduction',
    name: 'vinIntroduction',
    component: () => import(/* webpackChunkName: "vinIntroduction" */ '../views/VehicleHistory/vinIntroduction.vue')
  },
  {
    path: '/vehicle-history/how-to-buy',
    name: 'howToBuy',
    component: () => import(/* webpackChunkName: "howToBuy" */ '../views/VehicleHistory/howToBuy.vue')
  },
  {
    path: '/vehicle-history/vin-check',
    name: 'vinCheck',
    component: () => import(/* webpackChunkName: "vinCheck" */ '../views/VehicleHistory/vinCheck.vue')
  },
  {
    path: '/for-business',
    name: 'forBusiness',
    component: () => import(/* webpackChunkName: "forBusiness" */ '../views/ForBusiness/forBusiness.vue')
  },
  {
    path: '/personal',
    name: 'personal',
    meta: {
      requireAuth: true
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/personal/index.vue')
  },
  {
    path: '/pay-success',
    name: 'paySuccess',
    meta: {
      requireAuth: true
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/pay/paySuccess.vue')
  },
  {
    path: '/order',
    name: 'order',
    meta: {
      requireAuth: true
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/pay/order.vue')
  },
  {
    path: '/pay',
    name: 'pay',
    // meta: {
    //   requireAuth: true
    // },
    component: () => import(/* webpackChunkName: "about" */ '../views/pay/pay.vue')
  },
  {
    path: '/report-detail',
    name: 'reportDetail',
    meta: {
      requireAuth: true
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/reportDetail.vue')
  },
  {
    path: '/contact-us',
    name: 'contactUs',
    component: () => import(/* webpackChunkName: "about" */ '../views/ContactUs/contactUs.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
